import { HostListener, Injectable } from "@angular/core";
import { DGDrawingServiceGlobal } from "./DrawingService";
import { Subject } from 'rxjs';
import * as moment from "moment";
import { CookiesService } from "./cookieService";
import 'moment-timezone';
//import * as moment from "moment";

@Injectable({
  providedIn: "root"
})

export class MagnituderAlertsService {

  public newForegroundDiffStateObserver: Subject<string> = new Subject();
  public newBackgroundDiffStateObserver: Subject<string> = new Subject();

  public newVioletTimeInterval;
  public newgreyTimeInterval;

  public violetTime: string = '';
  public greyTime: string = '';


  public constructor(public cookieService:CookiesService) {

  }

  public setViolet(color: string, noUseCookies?:boolean) {

    if(!noUseCookies)
    {this.cookieService.setCookie("iViolet", this.violetTime, 100);
    this.violetTime = moment().tz("America/New_York").format("HH:mm:ss")}
 //   clearInterval(this.newVioletTimeInterval)
    this.newForegroundDiffStateObserver.next(color);


    // this.newVioletTimeInterval = setInterval(() => {
    //   this.violetTime++;
    // }, 1000)

  }

  public setGrey(color: string, noUseCookies?:boolean) {

    if(!noUseCookies)
    {this.greyTime = moment().tz("America/New_York").format("HH:mm:ss");
    this.cookieService.setCookie("iGrey", this.greyTime, 100);}

  //  clearInterval(this.newgreyTimeInterval)
    this.newBackgroundDiffStateObserver.next(color);

    // this.newgreyTimeInterval = setInterval(() => {
    //   this.greyTime++
    // }, 1000)
  }




}
